import { createAction } from "@reduxjs/toolkit";

/**
 * Émis lors d’un changement de section (route analytics) : chaque slice concerné
 * remet son état à l’initial (filtres / données chargées).
 */
export const resetAnalyticsOnSectionChange = createAction("app/resetAnalyticsOnSectionChange");
